export function addFavorites(favorites) {
    return {
      type: "ADD_FAVORITES",
      favorites
    }; 
  }

export function errorStatus(errorStatus) {
    return {
        type: "CHANGE_ERROR_STATUS",
        errorStatus
    }; 
}

